export const carouselInicio = [
    
    {
        "imagen" : "/assets/imgs/IMG_516.png",
        "url": ""
    },
   
     {
        "imagen" : "/assets/imgs/IMG_602.png",
        "url": ""
    },
     
    {
        "imagen" : "/assets/imgs/IMG_520.png",
        "url": ""
    },
    {
        "imagen" : "/assets/imgs/IMG_332.png",
        "url": ""
    },


]